import { render, staticRenderFns } from "./DefaultProfile.vue?vue&type=template&id=2f512563&scoped=true"
import script from "./DefaultProfile.vue?vue&type=script&lang=js"
export * from "./DefaultProfile.vue?vue&type=script&lang=js"
import style0 from "./DefaultProfile.vue?vue&type=style&index=0&id=2f512563&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f512563",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f512563')) {
      api.createRecord('2f512563', component.options)
    } else {
      api.reload('2f512563', component.options)
    }
    module.hot.accept("./DefaultProfile.vue?vue&type=template&id=2f512563&scoped=true", function () {
      api.rerender('2f512563', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profiles/DefaultProfile.vue"
export default component.exports